<button [ngbTooltip]="'Roll ' + description()" (click)="roll()">
    <app-diceIcons-D20></app-diceIcons-D20>
</button>
